import ajax from '@/utils/ajax';
import {
  QUERYCODE,
  SSOLOGIN,
  RESETPSD,

} from '@/assets/js/login';

const header = '/web';

// forgetPassword: 忘记密码
// login: 登录
export const queryCode = (data) => ajax(`${header}${QUERYCODE}?phone=${data.phone}&type=${data.type}`, {}, 'POST');
export const phoneLogin = (data) => ajax(SSOLOGIN, data, 'POST');
export const resetPsd = (data) => ajax(RESETPSD, data, 'PUT');

// v1/user/exam/choose-records/new-user/save
export const reqNewUserRecord = (data) => ajax(`${header}/v1/label-tree`, data, 'POST');
// 无痕验证获取验证码
export const reqPhonesliderCode = (data) => ajax(`${header}/v2/common/sms-code/send`, data, 'POST');
